
export type ExtractedInfo = {
    name?: string,
    description?: string,
    categories?: Array<string>
    startDate?: string
}

export type Dimensions = {
    width: number,
    height: number
}

export type Orientation = 0 | 90 | 180 | 270;

export type VideoMetadata = {
    duration: number,
    dimensions: Dimensions,
    fps: number,
    orientation: Orientation
}

export enum AssetSource {
    UPLOAD = "UPLOAD",
    RECORD = "RECORD",
};

export enum AssetRole {
    COMPETITION = "COMPETITION",
    JUMP = "JUMP",
    CONTEXT = "CONTEXT",
};

export type Asset = {
    id: string,
    email: string,
    source: AssetSource,
    role: AssetRole,
    url: string,                    // s3://[bucket]/[id].[extension]
    thumbUrl?: string,              // PDF thumb. s3://[bucket]/[id].png
    filename: string,
    name?: string,
    categories?: string[],
    description?: string,
    startDate?: string,
    mimeType: string,
    jumpId?: string,
    competitionId?: string,
    playbackId?: string,            // mux playback ID
    assetId?: string,               // mux asset ID
    metadata?: VideoMetadata,
    created: string,
    updated: string
}

